
export default {
  pma: {
    baseUrl:"https://pma.arrcencloud.net/kelzyyy.PatientWebApp/",
    headers: {
      CurrentInstitutionId: "B85BB2A8-8FC9-4A66-96C2-346DF538407E",
      InstitutionId:"B85BB2A8-8FC9-4A66-96C2-346DF538407E"
    },
    // baseUrl: "https://pma.arrcencloud.net/CDJXZYYY.PatientWebApp/",
    // baseUrls: "https://pma.arrcencloud.net/Arrcen.PatientWebApiV3.3/",
    // headers: {
    //   CurrentInstitutionId: "28403137-F599-47D7-A186-F3E92CE14CD4",
    //   InstitutionId: "28403137-F599-47D7-A186-F3E92CE14CD4"
    // },
    timeout: 20000
  },
  institution: {
    icon: require('../assets/images/klzyy.jpg'),
    hospitalNameCn: '库尔勒市中医医院',
    hospitalNameEn: "",
    telephone: '0996-8792156',
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js